<dojo-tree-chart
  [params]="params()"
  [matchingPaths]="matchingPaths()"
  [matchingPathColors]="matchingPathColors()"
  [hoveredPath]="hoveredPath()"
  [color]="color()"
  (pathHover)="onPathHover($event)"
/>
